import { AuthState } from './types'
import { CognitoUser } from '@aws-amplify/auth'

export const getUser = ({ user }: Pick<AuthState, 'user'>): CognitoUser => {
  return user
}

export const getUserName = ({
  user
}: Pick<AuthState, 'user'>): string | null => {
  return user ? user.getUsername() : null
}

export const getUserEmail = ({
  user
}: Pick<AuthState, 'user'>): string | null => {
  return user && user.attributes.hasOwnProperty('email')
    ? user.attributes.email
    : null
}

export const getUserGroups = ({ user }: Pick<AuthState, 'user'>): string[] => {
  if (user) {
    const key = 'cognito:groups'
    const payload = user.signInUserSession.accessToken.payload
    return payload.hasOwnProperty(key) ? payload[key] : []
  }
  return []
}
